import React from "react";
import { useBaseComponent } from "../../../../base/base-component";
import { message } from "antd";
import server from "../../../../server";
import { IData, IDesignation, IExperienceFormModel, IState } from "./types/experience.types";
import {
    fetchData,
    fetchDesignations,
    modelMapper,
    viewMapper
} from "./action/experience.action";
import ExperienceView from "./experience.view";
import DataLoading from "../../../../common/loading-data";
import { ScrollRestoration } from "react-router-dom";
import displayName = ScrollRestoration.displayName;


interface IExperienceProps {
    employeeId: string;
    goToNextTab: () => void;
}

const Experience = (props: IExperienceProps) => {
    const {state, updateState} = useBaseComponent<IExperienceProps, IState>(props, {
        initialState: () => ({
            // data: {
            //     experience: {} as IExperience,
            // },
            internal: {
                loading: false,
                currentTab: 0,
                isFormValid: true,
            },
            external: {
                designation: []
            }
        }),

        onInit: () => onInit()
    });

    async function onInit() {
        const designations: IDesignation[] = await fetchDesignations();
        updateState('external.designation', designations);
        if (props.employeeId) {
            const data = await fetchData(props.employeeId);
            const normalizedData = normalizeExperienceDesignationNames(
                data,
                designations
            );
            updateState('data', normalizedData);
        } else {
            message.error("Initialization failed: Employee ID not found!");
        }
    }

    function normalizeExperienceDesignationNames(data: IData, designations: IDesignation[]) {
        const {experience} = data;
        const resolveDesignationDisplayName = (
            designationItem?: { id: string; code: string; displayName?: string }
        ) =>
            designationItem?.displayName ??
            designations.find(desg => desg.id === designationItem?.id)?.displayName ??
            '';

        return {
            experience: {
                ...experience,
                designationItem: {
                    ...experience.designationItem,
                    displayName: resolveDesignationDisplayName(experience.designationItem),
                },
                previousExperiences: experience.previousExperiences?.map(prev => ({
                    ...prev,
                    designationItem: {
                        ...prev.designationItem,
                        displayName: resolveDesignationDisplayName(prev.designationItem),
                    },
                })),
            },
        };
    }


    async function onSubmit(data: IExperienceFormModel) {
        if (props.employeeId) {
            let payload = modelMapper(data);
            console.log("Experience Details Payload: ", payload);
            await server.employee.experience.update(props.employeeId, payload);
            message.success('Experience details submitted successfully!');
        } else {
            updateState('internal.isFormValid', false);
            message.error("Please fill in all required fields!");
        }
    }

    return (
        state.data === undefined ? <DataLoading title="Experience Details"/> :
            <ExperienceView
                loading={state.internal.loading}
                viewModel={viewMapper(state.data)}
                onSubmit={onSubmit}
                goToNextTab={props.goToNextTab}
                designations={state.external.designation}
            />
    )
}

export default Experience;
